import { className } from 'lib/css'
import { useEffect } from 'preact/hooks'
import { useFormattedDate } from 'ui/components/conversation/event/hooks/use-formatted-date'
import EventDivider from 'ui/components/conversation/event-divider'
import { useForceUpdate } from 'ui/hooks/utility-hooks'
import { microsecondsToMilliseconds } from 'ui/utils/general-utils'

const TimeIndicator = ({ event }) => {
  const forceUpdate = useForceUpdate()
  const { date, time, timeUntilMidnight, srText } = useFormattedDate(
    microsecondsToMilliseconds(event.payload.timeIndicator),
  )

  // At midnight, force a re-render so "Today" can become "Yesterday"
  useEffect(() => {
    const timeout = setTimeout(() => {
      forceUpdate()
    }, timeUntilMidnight)

    return () => {
      clearTimeout(timeout)
    }
  }, [forceUpdate, timeUntilMidnight])

  return (
    <EventDivider dividerType="time-indicator">
      <h2 className={className('divider__time')} aria-hidden="true">
        <span className={className('divider__time--date')}>{date}</span>
        <span className={className('divider__time--time')}>{time}</span>
      </h2>
      <p className={className('visually-hidden')}>{srText}</p>
    </EventDivider>
  )
}

export default TimeIndicator
